import {inject} from '@angular/core';
import {CanActivateChildFn, CanActivateFn, Router} from '@angular/router';
import {of, switchMap} from 'rxjs';
import {UserService} from "../../user/user.service";
import {User} from "../../user/user.types";
import {Roles} from "../../../modules/admin/roles/enums/roles.enum";

export const AdminCollaboratorGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(UserService).user$.pipe(
        switchMap((user: User) => {
            const userRoles: Roles[] = user.roles?.map((role) => role.id) ?? [];
            const adminCollaboratorRoles: Roles[] = [Roles.Admin, Roles.Collaborator];
            const isAdminOrCollaborator: boolean = userRoles.some(role => adminCollaboratorRoles.includes(role));
            if (!isAdminOrCollaborator) {
                return of(router.parseUrl('/error/403'));
            }
            // Allow the access
            return of(true);
        }),
    );
};
